import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

//Components
import Form from './Form';

// Actions de Redux
import { createProperty } from '../../redux/properties/thunks';
import useScan from '../../hooks/useScan';

const NewProperties = () => {
  const navigate = useNavigate();
  // utilizar use dispatch y te crea una función
  const dispatch = useDispatch<any>();
  const { setDestination } = useScan();

  useEffect(() => {
    setDestination('act-a-pro', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialValues = {
    address: '',
    country: process.env.REACT_APP_ENV_COUNTRY,
    observations: '',
  };

  // cuando el usuario haga submit
  const submitNewProperty = (values: any) => {
    // crear el nuevo warehouse
    dispatch(createProperty(values))
      .unwrap()
      .then((res: any) => {
        if (res) {
          navigate('/properties', { replace: true });
        }
      });
  };

  return (
    <Form
      submitProperty={submitNewProperty}
      initialValues={initialValues}
      actionText={'GUARDAR'}
      type={'agregar'}
    />
  );
};

export default NewProperties;
